import { addMinutes, interval } from 'date-fns';

import { EventDraft, OjEvent, StackEvent } from '../../../shared/api';

export function getEventInterval(event: EventDraft | OjEvent | StackEvent) {
  const startAt = event.start_at;
  return interval(startAt, addMinutes(startAt, event.duration));
}
